export default [
	{
		title:'第一条',
		text:'为加强对互联网用户账号名称的管理，保护公民、法人和其他组织的合法权益，根据《国务院关于授权国家互联网信息办公室负责互联网信息内容管理工作的通知》和有关法律、行政法规，制定本规定。'
	},
	{
		title:'第二条',
		text:'在中华人民共和国境内注册、使用和管理互联网用户账号名称，适用本规定。 　　本规定所称互联网用户账号名称，是指机构或个人在博客、微博客、即时通信工具、论坛、贴吧、跟帖评论等互联网信息服务中注册或使用的账号名称。'
	},
	{
		title:'第三条',
		text:'国家互联网信息办公室负责对全国互联网用户账号名称的注册、使用实施监督管理，各省、自治区、直辖市互联网信息内容主管部门负责对本行政区域内互联网用户账号名称的注册、使用实施监督管理。'
	},
	{
		title:'第四条',
		text:'互联网信息服务提供者应当落实安全管理责任，完善用户服务协议，明示互联网信息服务使用者在账号名称、头像和简介等注册信息中不得出现违法和不良信息，配备与服务规模相适应的专业人员，对互联网用户提交的账号名称、头像和简介等注册信息进行审核，对含有违法和不良信息的，不予注册；保护用户信息及公民个人隐私，自觉接受社会监督，及时处理公众举报的账号名称、头像和简介等注册信息中的违法和不良信息。'
	},
	{
		title:'第五条',
		text:'互联网信息服务提供者应当按照“后台实名、前台自愿”的原则，要求互联网信息服务使用者通过真实身份信息认证后注册账号。 　　互联网信息服务使用者注册账号时，应当与互联网信息服务提供者签订协议，承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。'
	},
	{
		title:'第六条',
		text:'任何机构或个人注册和使用的互联网用户账号名称，不得有下列情形：',
		sub:[
			'（一）违反宪法或法律法规规定的；',
			'（二）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
			'（三）损害国家荣誉和利益的，损害公共利益的；',
			'（四）煽动民族仇恨、民族歧视，破坏民族团结的；',
			'（五）破坏国家宗教政策，宣扬邪教和封建迷信的；',
			'（六）散布谣言，扰乱社会秩序，破坏社会稳定的； ',
			'（七）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
			'（八）侮辱或者诽谤他人，侵害他人合法权益的；',
			'（九）含有法律、行政法规禁止的其他内容的。',
		]
	},
	{
		title:'第七条',
		text:'互联网信息服务使用者以虚假信息骗取账号名称注册，或其账号头像、简介等注册信息存在违法和不良信息的，互联网信息服务提供者应当采取通知限期改正、暂停使用、注销登记等措施。'
	},
	{
		title:'第八条',
		text:'对冒用、关联机构或社会名人注册账号名称的，互联网信息服务提供者应当注销其账号，并向互联网信息内容主管部门报告。'
	},
	{
		title:'第九条',
		text:'对违反本规定的行为，由有关部门依照相关法律规定处理。'
	},
	{
		title:'第十条',
		text:'本规定自2023年9月1日施行'
	}

]